import { Switch, Route } from 'react-router-dom';

import DocsAuthenticationContainer from './DocsAuthenticationContainer';
import { JSX } from 'react';

const Routes = (): JSX.Element => (
  <Switch>
    <Route exact path="/docs">
      <DocsAuthenticationContainer />
    </Route>
  </Switch>
);

export default Routes;
